
import React, {Fragment, useEffect, useState} from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import {Form,Button,Spinner,Image} from 'react-bootstrap';
import axios from 'axios';
import logo from '../../img/logo_uam.png';
import Recepisse from '../../components/RecepisseInscription';
import AlerteMessage from '../../components/AlerteMessage';
import Input, {InputF,InputRadio} from '../../components/Input';
import InputT from '../../components/Input';
import Alert, { Alert2, Alert3 } from '../../components/Alerte';
import Update from '../Update/index';
import { useNavigate,useLocation } from 'react-router-dom';
import Pay from '../pay/Pay';
import PayUniforme from '../PayUniforme/Pay';
import { useRef } from 'react';
import './inscription.css';
import Env from '../../hooks/Env';
import InfomationEtudiant from '../../components/InfoEtudiant';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const Inscription = ({props}) => {
    useDocumentTitle('Réinscription');
    const { API_URL } = Env(); 
    const { search } = useLocation();
    const [ine,setIne] = useState(false)
    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [open, setOpen] = useState (false)
    const [message, setMessage] = useState (false)
    const [errMsg, setErrMsg] = useState('');
    const userRef = useRef();
    const errRef = useRef();
    const [auth, isAuth] = useState(false)
    const [dataForm, setDataForm] = useState('');
    const [photo, setPhoto] = useState(false);
    const [infos, setInfos] = useState('');
    const [update,setUpdate] = useState(false)
    const [valid, SetIsValid] = useState({
        isValidPhoneNumber: false,
      });
    const[ showEtudiant, setShowEtudiant] = useState(false)
    const [errors, setErrors] = useState(false);
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const [depotsuccess2, setDeppotSuccess2] = useState(false);
    const maxFileSize = 1024 * 1024 ; //1Mo
    const [show, setShow] = useState(false);
    const [complete, setComplete] = useState(false);
    const handleClose = () => setShow(false);
    const [selectedFiles, setSelectedFiles] = useState({
        "copie_carte_id" : true,
        "releve" : true,
        "diplome_bac" : true,
        "visite_medicale" : true,
        "photo" : true,
    });
    const [gestionfichier, setGestionFichier] = useState({
        "copie_carte_id" : false,
        "releve" : false,
        "diplome_bac" : false,
        "visite_medicale" : false,
        "photo" : true,
    });
    const match = search.match(/email=(.*)/);
    const email = match?.[1];
    useEffect (() => {
        if (!email) {
           // console.log("pas encore de mail dans la requete ")
        } else {
            axios({
                url:`${API_URL}/reinscription/test/?email=${email}`,
                method: 'POST',
            })
            .then(result => {
                console.log(result.data)
                if (result?.data?.message || result?.data?.detail) {
                    console.log("impossile de retrouver le candidat");
                    navigate("/");
                } else {
                     console.log('donnes : ', result?.data);
                     setData(result?.data?.data);
                     setDeppotSuccess(true);
                    //  isAuth(true)
                    //  setInfos(result.data.data)
                     
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });
        }
        
       }, [email])
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState();  /*données d'un user avec dépot réussie */
    const handleFileChange = (event, key) => {
        const elements = document.getElementsByName(key)
        // console.log(selectedFiles.publication7)
        let file = event.target.files[0];
        console.log(file.type)
        if (file?.size < maxFileSize){
            if (key === 'photo') {
                if (file.type ==='image/jpeg') {
                    var filesinfos = file.slice(0, file.size, 'image/jpeg'); 
                    file = new File([filesinfos], `${infos.codePermanent}.jpeg`, {type: 'image/jpeg'});
                    console.log(file)
                    setPhoto(false)
                    setSelectedFiles((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: file
                    }));
                    setGestionFichier((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: true
                    }));
                    for (var i = 0; i < elements.length; i++) {
                        var element1 = elements[i];
                        // console.log(element)
                        // Faites quelque chose avec chaque élément, par exemple :
                        element1.style.border = ""; // Applique une bordure rouge
                        // ... autres opérations sur l'élément
                    }
                } else {
                    setPhoto(true)
                    setOpen(true)
                    setMessage("format de fichier non permis")
                    console.log("format de fichier non permis ")
                    setGestionFichier((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: false
                    }));
                    return
                }
                
            } else {
                console.log(file)
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: file
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: true
                }));
                for (var J = 0; J < elements.length; J++) {
                    var element = elements[J];
                    // console.log(element)
                    // Faites quelque chose avec chaque élément, par exemple :
                    element.style.border = ""; // Applique une bordure rouge
                    // ... autres opérations sur l'élément
                }
            }
            
        } else {
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            for (var j = 0; j < elements.length; j++) {
                var element2 = elements[j];
                // console.log(element)
                // Faites quelque chose avec chaque élément, par exemple :
                element2.style.border = "2px solid #BC0C0C";
                element2.style.transition ='border 0.5s ease-in-out;' // Applique une bordure rouge
                // ... autres opérations sur l'élément
            }

        }
    };
    const navigate = useNavigate('')
    const handleCheckbox = (event) => {
        setDataForm({ ...dataForm, [event.target.name]: event.target.value });
        console.log(event.target.value)
        
    }
    function handleChange (e) {
        const name= e.target.name;
        let value = e.target.value;
        // console.log(value,name)
        if (name === 'telephone' ) {
            const phoneRegex = /^\d{9}$/;  //validation numéro de téléphone
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: phoneRegex.test(value),
            }));
        }
        setDataForm({ ...dataForm, [name]: value });
        // console.log(value,name)
    }
    let campagne;
    const handleSubmit = async (e) => {
        if (!auth) {
            axios({
                url:`${API_URL}/reinscription/confirmed/?codePermanent=${pwd}&email=${user}`,
                method: 'GET',
            })
            .then(result => {
                // console.log(result.data.data)
                if (result.data.detail) {
                    console.log(result.data.detail)
                    setOpen(true)
                    setMessage(result.data.detail)
                    setErrors(true)
                } else {
                    setIne(true) ;
                    isAuth(true);
                        if (result.data.data.niveau ==='master') {
                            campagne ='master'
                        } else {
                            campagne ='reinscription'
                        }
                        setInfos(result.data.data) ;
                        setShowEtudiant(true) ;
                }
            })
            .catch((error) => {
                console.error('Error:', error)
                setOpen(true)
                setMessage('Erreur veuiller réessayer')
                
            });
        } else {
            try {
                e.preventDefault();
                const formData = new FormData();
                formData.append('email',infos.email)
                formData.append('date_naissance',infos.date_naissance)
                formData.append('prenom',infos.prenom)
                formData.append('nom',infos.nom)
                formData.append('codePermanent',infos.codePermanent)
                const nameFiles = ["copie_carte_id","releve","diplome_bac","visite_medicale","photo"]
                for (const i in nameFiles) {
                    if (selectedFiles[nameFiles[i]]) {
                        if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                            formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                        } else {
                            
                        }
                    }
                }
                for (let key in dataForm) {
                    // console.log(dataForm[key])
                    if (dataForm.hasOwnProperty(key)) {
                          if( dataForm[key] !== null) {
                            if (key === 'pays') {
                                if (dataForm['type_poste'] === 'PATS') {
                                    if (dataForm['pays'] !== 'senegal') {
                                        dataForm['pays'] = 'SENEGAL'
                                    }
                                }
                            }
                            formData.append(key ,dataForm[key])
                          }
                  }
                }
                var showALerte = nameFiles.some(field => selectedFiles[field] === false);
             for (let pair of formData.entries()) {
                    console.log(pair[0] + ':' + pair[1]);
                  }
                if (valid.isValidPhoneNumber) {
                    console.log("pas valide")
                    // setMessageAlerte('Incorrect')
                    // setShow(true);
                
                }
                else if (photo) {
                    setOpen(true)
                    setMessage('Format de la photo incorrect')
                }
                else if (showALerte) {
                     setShow(true);
                    //  setOk(false)
                }
                else {
                    setComplete(true)
                    setSubmitted(true);
                    // console.log("Requete en cours d'envoi ...")
                    const response = await axios.post(
                        'https://depot.uam.sn/api/v1/reinscription/update/',
                        formData,
                {
                        headers: {
                        'Content-Type': 'multipart/form-data',
                        },
                        });
                // console.log(response)
                if (response.status === 200) {
                    if (response.data.detail) {
                        setSubmitted(false);
                        // console.log(response.data.detail)
                        setDeppotSuccess2(true)
                    } else {
                        // console.log(response)
                        setSubmitted(false);
                        // console.log('Files uploaded successfully');
                        // console.log('Recepissé :' + response?.data?.data)
                        const dataPersonDepot = response?.data?.data;
                        setData(dataPersonDepot);
                        setDeppotSuccess(true);
                        // console.log("message : " + response.data.message);
                        // console.log(data);
                    }
                } else {
                    console.error('Error uploading files');
                    console.log("Détail de la réponse ",response.status)
                }
            }
        } catch (error) {
            setSubmitted(false);
           console.error('Error', error);
        }
    }
        
};
    function handleUpdate () {
        update ? setUpdate(false) : setUpdate(true)
        
    }
    const handleClose3 = () => {
        setOpen(false)
    }
  return (
    <>
        <AlerteMessage open={open} handleClose={handleClose3} message={message} />
        <Alert show={show} handleClose={handleClose} />
        {depotsuccess2 ? <Alert2 message = 'Impossible de postuler, votre candidature a deja été enregistrée' /> : null }
        {showEtudiant ? <InfomationEtudiant infos={infos} /> : null }
        {depotsuccess ? <Recepisse  dataPerson={data}/> : null}
        {update ? <Update /> : null}
        <div>
            <div className='ml-2 mt-2' style={{display:'flex','justifyContent':'right'}}>
              
            </div>
            {/* {aprés authentification} */}
            {auth ? 
            <>
             {ine
              ? <PayUniforme infos={infos}/> : 
              <div className='container mb-2 ' id='mainDepot'>
              <div id='nameModule' className=''>
                  <p> {'Informations Complémentaires' }</p>
              </div>
              <div id="form" className='inscription'>
                  <Form onSubmit={handleSubmit}>
                  <div id="step1" className='mb-3'>
                      <Input type='email' readOnly={true} className='' required={false}  value={infos.email} label="Adresse mail" name='email'/>
                      <div className='row' id='test'>
                      <Input readOnly={true} required={false} className="col-md-6 col-sm-12" value={infos.prenom}  type='text' label="Prénom (s)" name='prenom' />
                      <Input readOnly={true} required={false} className="col-md-6 col-sm-12" value={infos.nom} type='text' label="Nom" name='nom'/>
                      </div>
                      <div className='row'>
                          <Input className="" readOnly={ true} value={infos.codePermanent} type='text' label="Code Permanent" name='codePermanent'/>
                      </div> 
                     
                  </div>
                  <div id="files">
                  <InputF required={true}  className="rounded-left mb-2" label="Certificat de visite et de contre visite " message={<span style={{color:'red'}}>*</span>} type='file' name='visite_medicale' onChange={(e) => handleFileChange(e,"visite_medicale")} />
                  {!selectedFiles["visite_medicale"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo veuiller le réduire . </span>: null} 
                  
                  </div>
                  <div className="buttons">
                  <Button  variant="primary" type='submit' size="md"
                  className="p-2 float-end mb-2">
                      Valider  {submitted ?
                          <Spinner animation="grow"
                          size="sm" role="status"
                          >
                          <span className="visually-hidden">Loading...</span>
                          </Spinner>
                          : null}
                  </Button>
                  </div>
                  </Form>
              </div>
          </div>
             }
           
            </>
           
            // { s'il n'est pas authentifié !}
            : <Form onSubmit={handleSubmit} style={{display:"inline-block"}}>
                <p ref={errRef} className={errMsg ? "errMsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
                <div className="row container border border-primary depotdossier" id="test">
                    <div id="bodyForm">
                        <div>
                        <p><Image src={logo} width={90} height={100} /> <br /> <b>Réinscription Pédagogique</b></p>
                        </div>
                        <Form.Group className="col-12" controlId="formBasicEmail">
                            <Form.Label className=''><h5>Email institutionnelle : </h5></Form.Label>
                            <Form.Control
                                    type="email"
                                    name="email"
                                    value = {user}
                                    onChange={(e) => setUser(e.target.value)}
                                    placeholder="Enter email"
                                    required
                                />
                        </Form.Group>
                        <Form.Group className="col-12" controlId="formBasicPassword">
                            <Form.Label className=''><h5>Code Permanent : </h5></Form.Label>
                                <Form.Control
                                        type="codepermanent"
                                        name="codepermanent"
                                        value={pwd}
                                        onChange={(e) => setPwd(e.target.value)}
                                        placeholder="123456"
                                        required  
                                    />
                        </Form.Group>
                    </div>
                    <div>
                        <Button
                            variant="success"
                            id="test"
                            className="btn-xl float-start"
                            style={{margin:'9px'}}
                            onClick={handleSubmit}
                            >
                            connexion {submitted ? <Spinner animation="grow" size="sm" role="status" /> : null}
                        </Button>
                    </div>
                </div>
            </Form>}
        </div>
    </>
  )
}
export default Inscription
